export default "__VITE_ASSET__Ds4x582q__"